import React, { useState } from 'react';
import './Players.css';

const Players = ({ onClose, players }) => {
  const [sorting, setSorting] = useState({
    field: 'name',
    direction: 'asc'
  });
  const [searchText, setSearchText] = useState('');

  const sortPlayersList = (players, field, direction) => {
    return [...players].sort((a, b) => {
      let comparison = 0;
      switch (field) {
        case 'name':
          comparison = a.name.localeCompare(b.name);
          break;
        case 'team':
          comparison = a.team.localeCompare(b.team);
          break;
        case 'position':
          comparison = a.position.localeCompare(b.position);
          break;
        case 'projected':
          comparison = a.projected - b.projected;
          break;
        default:
          comparison = 0;
      }
      return direction === 'asc' ? comparison : -comparison;
    });
  };

  const handleSort = (field) => {
    setSorting(prev => ({
      field,
      direction: prev.field === field && prev.direction === 'asc' ? 'desc' : 'asc'
    }));
  };

  const sortedPlayers = sortPlayersList(
    players.filter(player =>
      player.name.toLowerCase().includes(searchText.toLowerCase())
    ),
    sorting.field,
    sorting.direction
  );

  return (
    <div className="players-view">
      <div className="app-header">
        <h1>Useful Chaos' Fantasy Drafter - Players</h1>
        <button className="close-button" onClick={onClose}>
          Close
        </button>
      </div>

      <div className="players-content">
        <input
          type="text"
          className="players-search-bar"
          placeholder="Search players..."
          value={searchText}
          onChange={(e) => setSearchText(e.target.value)}
        />
        <table className="players-table">
          <thead>
            <tr>
              <th onClick={() => handleSort('name')} className="sortable">
                Name {sorting.field === 'name' && (sorting.direction === 'asc' ? '↑' : '↓')}
              </th>
              <th onClick={() => handleSort('team')} className="sortable">
                Team {sorting.field === 'team' && (sorting.direction === 'asc' ? '↑' : '↓')}
              </th>
              <th onClick={() => handleSort('position')} className="sortable">
                Position {sorting.field === 'position' && (sorting.direction === 'asc' ? '↑' : '↓')}
              </th>
              <th onClick={() => handleSort('projected')} className="sortable">
                Projected {sorting.field === 'projected' && (sorting.direction === 'asc' ? '↑' : '↓')}
              </th>
            </tr>
          </thead>
          <tbody>
            {sortedPlayers.map((player, index) => (
              <tr key={index}>
                <td>{player.name}</td>
                <td>{player.team}</td>
                <td>{player.position}</td>
                <td>{player.projected.toFixed(1)}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      <div className="footer">
        © 2025 - <a href="https://www.usefulchaos.com" target="_blank" rel="noopener noreferrer">UsefulChaos.com</a>
      </div>
    </div>
  );
};

export default Players;